<div
  class="container flex flex-column align-items-center justify-content-center bg-white max-w-25rem border-round"
>
  <span class="pi pi-exclamation-triangle color-danger text-7xl"></span>
  <h1 class="text-center">{{ title$ | async }}</h1>
  <p class="text-center">{{ 'errorPage.unableToAccess' | translate }}</p>
  <p class="text-center">{{ 'errorPage.contactAdministrator' | translate }}</p>
  <br />
  <a
    (click)="logOut()"
    class="font-bold text-base cursor-pointer hover:underline"
    data-testid="shared-error-signin-link"
  >
    Return to Sign In
  </a>
</div>
